import React, { lazy, Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Loading from 'components/shared-components/Loading';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';

export const AuthViews = ({ flags }) => {
  
  return (
    <Suspense fallback={<Loading cover="page" fallback={true} />}>
      <Switch>
        <Route path={'/verify'} component={lazy(() => import('./verify'))} />
        <Route path={'/confirm'} component={lazy(() => import('./confirm'))} />
        <Route path={'/mobile-app'} component={lazy(() => import('./mobile-app'))} />
        <Route path={'/forgot'} component={lazy(() => import('./forgot'))} />
        <Route path={'/join'} component={lazy(() => import('./join'))} />
        <Route path={'/login'} component={lazy(() => import('./login'))} />
        <Route path={'/reset'} component={lazy(() => import('./reset'))} />
        <Route path={'/sign-up'} component={lazy(() => import('./sign-up'))} />
        <Redirect from={''} to={'/login'} />
      </Switch>
    </Suspense>
  )
}

export default withLDConsumer()(AuthViews);
//export default AuthViews;

